export const SRS_STAGES = {
  APPRENTICE: {label: 'Apprentice', stages: '1,2,3,4'},
  GURU: {label: 'Guru', stages: '5,6'},
  MASTER: {label: 'Master', stages: '7'},
  ENLIGHTENED: {label: 'Enlightened', stages: '8'},
  BURNED: {label: 'Burned', stages: '9'}
}

export const RESOURCE_TYPES = {
  ASSIGNMENTS: 'assignments',
  SUBJECTS: 'subjects',
  USER: 'user',
}

export const SUBJECT_TYPES = [
  'Kanji',
  'Radical',
  'Vocabulary',
]